/**
 * TerminalHeader — IDENTITY:P3.A Terminal Header Bar
 *
 * Displays user identity in Maestro terminal aesthetic:
 * "maestro-ai -- {alias}'s intelligence console" with 24px avatar badge.
 * Responsive: full text at md+, truncated alias at sm, avatar-only at xs.
 *
 * Solution Proposal: SOL-20260309-IDENTITY-P3
 */

import React from 'react';
import AvatarDisplay from '../avatar/AvatarDisplay';

export default function TerminalHeader({
  alias,
  avatarUrl,
  fallbackLetter,
  fallbackColor,
  className = '',
}) {
  const displayLetter = fallbackLetter || (alias ? alias[0].toUpperCase() : '?');

  return (
    <nav
      aria-label={`${alias || 'User'}'s Maestro terminal`}
      className={`bg-zinc-950 border-b border-zinc-800 ${className}`}
    >
      <div className="flex items-center gap-3 px-4 py-2">
        <AvatarDisplay
          avatarUrl={avatarUrl}
          size={24}
          fallbackLetter={displayLetter}
          fallbackColor={fallbackColor}
          showBorder={false}
        />
        <span className="hidden md:inline text-[#D4A03C] font-maestro-mono text-sm">
          maestro-ai &mdash; <span className="font-bold">{alias}</span>&apos;s intelligence console
        </span>
        <span className="hidden sm:inline md:hidden text-[#D4A03C] font-maestro-mono text-sm truncate max-w-[150px]">
          <span className="font-bold">{alias}</span>
        </span>
      </div>
    </nav>
  );
}
